import React from 'react';

import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { GiroPayment } from 'types/state';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { TextComponent } from 'design/text/textComponents';
import { ThemeProviderComponent } from 'design/themeProvider';

type Props = {
  giroPayment: GiroPayment;
  active: boolean;
  onClick(id: number): void;
};

export const GiroPaymentsTableRow = (props: Props) => {
  const { giroPayment, active, onClick } = props;

  const intl = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(giroPayment.id);
  }, [onClick, giroPayment.id]);

  const recievedAtText = giroPayment.recievedAt
    ? intl.shared.dates.calendarDateWithTime(new Date(giroPayment.recievedAt))
    : '-';

  const updatedAtText = giroPayment.updatedAt
    ? intl.shared.dates.calendarDateWithTime(new Date(giroPayment.updatedAt))
    : '-';

  const statusText = giroPayment.status
    ? intl.shared.giroPaymentStatusValue(giroPayment.status)
    : '-';

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={`${giroPayment.id}`} />
      <TableTd text={giroPayment.from.unp} />
      <TableTd text={giroPayment.org.name || '-'} />
      <TableTd
        text={normalizeProfileLike(giroPayment.person).toFullName() || '-'}
      />
      <TableTd text={recievedAtText} />
      <TableTd
        text={
          giroPayment.creditedTransaction
            ? intl.shared.paymentTransactionText(
                giroPayment.creditedTransaction
              )
            : '-'
        }
      />
      <TableTd
        text={intl.shared.paymentTransactionText(
          giroPayment.recievedTransaction
        )}
      />
      {giroPayment.status === 'CLIENT_FOUND' ? (
        <ThemeProviderComponent>
          <TableTd
            text={
              <TextComponent color="successful" size="s">
                {statusText}
              </TextComponent>
            }
          />
        </ThemeProviderComponent>
      ) : (
        <TableTd
          text={
            <TextComponent
              color={
                giroPayment.status === 'CLIENT_NOT_FOUND'
                  ? 'critical'
                  : giroPayment.status === 'FAILED'
                  ? 'secondary'
                  : 'primary'
              }
              size="s"
            >
              {statusText}
            </TextComponent>
          }
        />
      )}
      <TableTd text={updatedAtText} />
    </TableTr>
  );
};
